import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createCommentVNode("todo: handle the auth response and show something to the user based off that state"),
    _createCommentVNode("e.g. did it fail? did they not consent? "),
    _cache[0] || (_cache[0] = _createElementVNode("h4", null, "Logging in...", -1 /* HOISTED */))
  ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
}